import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const AdvertisementList = () => {
  const [AdvertisementUser, setAdvertisementUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ Correct API endpoint
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_advertisement"
        );

        if (response.data.status === true) {
          setAdvertisementUser(response.data.data);
        } else {
          toast.error("Failed to fetch advertisements");
        }
      } catch (error) {
        console.error(error);
        toast.error("API Error");
      }
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {

      const formData = new FormData();
      formData.append("id", userId);


      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_advertisement",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === true) {
        setAdvertisementUser((prev) =>
          prev.filter((user) => user.id !== userId)
        );
        toast.error(response.data.message || "Advertisement deleted!");
        navigate("/Advertisement");
      } else {
        toast.error("Delete failed.");
      }
    } catch (error) {
      console.error("Delete error", error);
      toast.error("Failed to delete Advertisement.");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Categories List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript: void(0);">Categories</Link>
                </li>
                <li className="breadcrumb-item active">Categories List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Advertisement Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title flex-grow-1">All Categories List</h4>
                <Link to="/Advertisement-add" className="btn btn-sm btn-primary">
                  Add Advertisement
                </Link>
              </div>

              <div className="table-responsive">
                <table className="table align-middle mb-0 table-hover table-centered">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th></th>
                      <th>Categories</th>
                      <th>Create Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {AdvertisementUser.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <input type="checkbox" className="form-check-input" />
                        </td>

                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                              <img
                                src={
                                  item.image
                                    ? `https://cyberathon.com/multivendor/${item.image}`
                                    : "/images/no-image.png"
                                }
                                alt="Advertisement"
                                className="avatar-md"
                              />
                            </div>

                            <p className="text-dark fw-medium fs-15 mb-0">
                              {item.title}
                            </p>
                          </div>
                        </td>

                        <td>{item.created_at || "N/A"}</td>

                        <td>
                          <div className="d-flex gap-2">
                            <Link
                              to={`/Advertisement-view/${item.id}`}
                              className="btn btn-light btn-sm"
                            >
                              <i className="fa-solid fa-eye fs-18"></i>
                            </Link>

                            <Link
                              to={`/Advertisement-edit/${item.id}`}
                              className="btn btn-soft-primary btn-sm"
                            >
                              <i className="fa-solid fa-pencil fs-18"></i>
                            </Link>

                            <span
                              onClick={() => deleteUser(item.id)}
                              className="btn btn-soft-danger btn-sm"
                            >
                              <i className="fa-solid fa-trash fs-18"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination (Not changed) */}
              <div className="card-footer border-top">
                <nav>
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <Link className="page-link">Previous</Link>
                    </li>
                    <li className="page-item active">
                      <Link className="page-link">1</Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link">2</Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link">3</Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link">Next</Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};


export const AdevrtisementCreate = () => {
  const navigate = useNavigate();
  const initialFormState = {
    title: "",
    cat_stock: "",
    cat_created_by: "",
    status: "",
  };

  const [AdevrtisementUser, setAdevrtisementUser] = useState(initialFormState);
  const [Adevrtisementimage, setAdevrtisementImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setAdevrtisementUser({ ...AdevrtisementUser, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setAdevrtisementImage(file);
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    } else {
      setPreviewImage(null);
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!AdevrtisementUser.title?.trim()) {
      toast.error("Please enter Advertisement title");
      return;
    }

    const formData = new FormData();
    formData.append("title", AdevrtisementUser.title.trim());

    if (AdevrtisementUser.cat_created_by) {
      formData.append("created_by", AdevrtisementUser.cat_created_by.trim());
    }

    if (AdevrtisementUser.cat_stock !== "") {
      formData.append("stock", AdevrtisementUser.cat_stock);
    }
    
    if (AdevrtisementUser.status) {
      formData.append("status", AdevrtisementUser.status);
    }

    if (Adevrtisementimage) {
      formData.append("image", Adevrtisementimage);
    }

    try {
      setIsSubmitting(true);
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_advertisement",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data && response.data.status === true) {
        toast.success(response.data.message || "Advertisement added successfully!");
        setAdevrtisementUser(initialFormState);
        setAdevrtisementImage(null);
        setPreviewImage(null);
        navigate("/Advertisement");
      } else {
        const msg = response.data?.message || "Failed to add Advertisement";
        toast.error(msg);
      }
    } catch (error) {
      console.error("Add Advertisement error:", error);
      toast.error("Something went wrong while adding Advertisement.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Create Advertisement</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Advertisement</a>
                </li>
                <li className="breadcrumb-item active">Create Advertisement</li>
              </ol>
            </div>
          </div>
        </div>

        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-xl-9 col-lg-8 ">
            <form onSubmit={submitForm} encType="multipart/form-data">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Add Image</h4>
                </div>
                <div className="card-body">
                  <div className="dropzone bg-light-subtle py-5">
                    <label className="form-label text-dark">Image</label>
                    <input
                      type="file"
                      id="cat-image"
                      className="form-control"
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                    {previewImage && (
                      <img
                        src={previewImage}
                        alt="Preview"
                        className="mt-2"
                        style={{ width: "100px", height: "auto" }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">General Information</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Advertisement Title</label>
                        <input
                          type="text"
                          id="title"
                          name="title"
                          onChange={handleInput}
                          value={AdevrtisementUser.title}
                          className="form-control"
                          placeholder="Enter Title"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Created By</label>
                      <select
                        className="form-control"
                        id="cat_created_by"
                        name="cat_created_by"
                        onChange={handleInput}
                        value={AdevrtisementUser.cat_created_by}
                        data-placeholder="Select Crater"
                      >
                        <option value="">Select Crater</option>
                        <option value="Seller">Seller</option>
                        <option value="Admin">Admin</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Stock</label>
                        <input
                          type="number"
                          id="cat_stock"
                          name="cat_stock"
                          onChange={handleInput}
                          value={AdevrtisementUser.cat_stock}
                          className="form-control"
                          placeholder="Quantity"
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <select
                        className="form-control"
                        id="status"
                        name="status"
                        onChange={handleInput}
                        value={AdevrtisementUser.status}
                        data-placeholder="Select Status"
                      >
                        <option value="">-- Select Status --</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button
                      type="submit"
                      className="btn btn-outline-secondary w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save Change"}
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/Advertisement" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};


export const AdvertisementEdit = () => {
  const [AdvertisementEditUser, setAdvertisementEditUser] = useState({
    id: "",
    title: "",
    cat_stock: "",
    status: "",
    cat_created_by: "",
    image: "",
  });

  const [AdvertisementImage, setAdvertisementImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const { id } = useParams();
  console.log("Advertidsement ID:" , id)
  const navigate = useNavigate();

  useEffect(() => {
  const fetchAdvertisement = async () => {
    try {
      const formData = new FormData();
      formData.append("id", id); // EXACT key as Postman

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_advertisement",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Fetch Advertisement Response:", response.data);

      if (response.data.status === true) {
        const result = response.data.data;

        setAdvertisementEditUser({
          id: result.id,
          title: result.title || "",
          cat_stock: result.cat_stock || "",
          status: result.status || "",
          cat_created_by: result.cat_created_by || "",
          image: result.image || "",
        });

        setPreviewImage(
          result.image
            ? `https://cyberathon.com/multivendor/${result.image}`
            : null
        );
      } else {
        toast.error("Failed to fetch Advertisement!");
      }
    } catch (error) {
      console.error("Error fetching Advertisement:", error);
      toast.error("Failed to fetch Advertisement!");
    }
  };

  if (id) fetchAdvertisement();
}, [id]);


  const changeHandler = (e) => {
    const { name, value } = e.target;
    setAdvertisementEditUser({ ...AdvertisementEditUser, [name]: value });
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    setAdvertisementImage(file);
    if (file) setPreviewImage(URL.createObjectURL(file));
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("id", id);
    formData.append("title", AdvertisementEditUser.title);
    
    if (AdvertisementEditUser.cat_stock) {
      formData.append("stock", AdvertisementEditUser.cat_stock);
    }
    
    if (AdvertisementEditUser.status) {
      formData.append("status", AdvertisementEditUser.status);
    }
    
    if (AdvertisementEditUser.cat_created_by) {
      formData.append("created_by", AdvertisementEditUser.cat_created_by);
    }

    if (AdvertisementImage) {
      formData.append("image", AdvertisementImage);
    }

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_advertisement",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "Advertisement updated successfully");
        navigate("/Advertisement");
      } else {
        toast.error(response.data.message || "Failed to update Advertisement");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* PAGE TITLE */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Advertisement Edit</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Advertisement</a>
                </li>
                <li className="breadcrumb-item active">Advertisement Edit</li>
              </ol>
            </div>
          </div>
        </div>

        {/* FORM */}
        <div className="row">
          <div className="col-xl-9 col-lg-8 ">

            {/* IMAGE SECTION */}
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Thumbnail Photo</h4>
              </div>
              <div className="card-body">
                <div className="dropzone bg-light-subtle py-5 text-center">
                  <input type="file" onChange={handleImage} />
                  {previewImage && (
                    <img
                      src={previewImage}
                      alt="Preview"
                      className="mt-3"
                      style={{ width: "100px" }}
                    />
                  )}
                </div>
              </div>
            </div>

            {/* GENERAL INFO */}
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">General Information</h4>
              </div>
              <div className="card-body">
                <form onSubmit={submitForm}>
                  <div className="row">

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Advertisement Title</label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={AdvertisementEditUser.title}
                        onChange={changeHandler}
                        required
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Created By</label>
                      <select
                        className="form-control"
                        name="cat_created_by"
                        value={AdvertisementEditUser.cat_created_by}
                        onChange={changeHandler}
                      >
                        <option value="">Select Crater</option>
                        <option value="Seller">Seller</option>
                        <option value="Admin">Admin</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Stock</label>
                      <input
                        type="number"
                        className="form-control"
                        name="cat_stock"
                        value={AdvertisementEditUser.cat_stock}
                        onChange={changeHandler}
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={AdvertisementEditUser.status}
                        onChange={changeHandler}
                      >
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="InActive">InActive</option>
                      </select>
                    </div>

                  </div>

                  <div className="p-3 bg-light mb-3 rounded">
                    <div className="row justify-content-end g-2">
                      <div className="col-lg-2">
                        <button type="submit" className="btn btn-outline-secondary w-100">
                          Save Change
                        </button>
                      </div>
                      <div className="col-lg-2">
                        <Link to="/Advertisement" className="btn btn-primary w-100">
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </div>

                </form>
              </div>
            </div>

          </div>
        </div>

      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};


export const AdvertisementView = () => {
  const [AdvertisementUser, setAdvertisementUser] = useState({
    id: "",
    title: "",
    image: "",
    created_at: "",
    updated_at: ""
  });

  const { id } = useParams();

  useEffect(() => {
    const fetchAdvertisement = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_advertisement",
          { id: id }
        );

        if (response.data.status === true) {
          setAdvertisementUser(response.data.data);
        } else {
          console.error("Failed to load Advertisement");
        }
      } catch (error) {
        console.error("There was an error!", error);
      }
    };

    fetchAdvertisement();
  }, [id]);

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Categories View</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript:void(0);">Categories</Link>
                </li>
                <li className="breadcrumb-item active">Categories View</li>
              </ol>
            </div>
          </div>
        </div>

        {/* VIEW CARD */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card Advertisement-view">

              <div className="cross-icon">
                <Link to="/Advertisement">
                  <i className="fa-solid fa-circle-xmark"></i>
                </Link>
              </div>

              <div>
                <img
                  src={
                    AdvertisementUser.image
                      ? `https://cyberathon.com/multivendor/${AdvertisementUser.image}`
                      : "/images/no-image.png"
                  }
                  width={600}
                  height={400}
                  alt="Advertisement Image"
                />
              </div>

              <strong>Advertisement Name</strong>
              <p>{AdvertisementUser.title}</p>

              <strong>Created At</strong>
              <p>{AdvertisementUser.created_at || "N/A"}</p>

              <strong>Updated At</strong>
              <p>{AdvertisementUser.updated_at || "N/A"}</p>

            </div>
          </div>
        </div>

      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
};